import { render, staticRenderFns } from "./purchase_order.vue?vue&type=template&id=db606142"
import script from "./purchase_order.vue?vue&type=script&lang=js"
export * from "./purchase_order.vue?vue&type=script&lang=js"
import style0 from "./purchase_order.vue?vue&type=style&index=0&id=db606142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports